<div class="ion-padding">
  <!-- header -->
  <div class="step-header">
    <ion-button
      [attr.aria-label]="'btn_back' | ariaLabel | translate"
      *ngIf="hideBack !== true"
      [disabled]="disabled === true"
      fill="clear"
      color="light"
      class="step-header-btn step-header-btn--left ion-no-margin"
      (click)="back.emit()">
      <ion-icon name="arrow-back-outline"></ion-icon>
    </ion-button>
    <img
      *ngIf="logoVisible && !!logoUrl"
      [attr.alt]="appIntroMessage | ariaLabel | translate"
      role="img"
      aria-live="assertive"
      [attr.aria-label]="appIntroMessage | ariaLabel | translate"
      class="logo"
      [src]="logoUrl"/>
    <h2
      *ngIf="!logoVisible && !!title"
      class="title-2 step-header-title ion-text-center ion-no-margin">
      <ion-text color="light">
        {{ title | translate }}
      </ion-text>
    </h2>
    <ion-button
      [attr.aria-label]="'select_assistance' | ariaLabel | translate"
      *ngIf="hideState !== true"
      [disabled]="disabled === true"
      fill="clear"
      class="step-header-btn step-header-btn--right ion-no-margin"
      (click)="openState()">
      <ion-icon slot="icon-only" src="assets/icons/question.svg"></ion-icon>
    </ion-button>
  </div>

  <!-- barra di navigazione -->
  <div *ngIf="!hideProgress && (totalSteps > 0 || absolute)" class="ion-margin-top">
    <ion-grid class="ion-no-padding">
      <ion-row class="ion-justify-content-center">
        <ion-col sizeLg="4" size="12">
          <div class="step-bar">
            <!-- barra di progresso relativa -->
            <ng-container *ngIf="!absolute">
              <div
                *ngFor="let item of segments; let index = index"
                [style.width.%]="100 / segments.length"
                class="step">
                <div class="step-content">
                  <span
                    class="step-filler"
                    [ngClass]="{ active: index <= activeIndex }">
                  </span>
                </div>
              </div>
            </ng-container>
            <!-- barra di progresso assoluta -->
            <ng-container *ngIf="absolute">
              <div [style.width.%]="100" class="step">
                <div class="step-content">
                  <span
                    class="step-filler active"
                    [style.width.%]="progress"
                  ></span>
                </div>
              </div>
            </ng-container>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>


